import { adminPartnerQueryKeys as e } from "./useAdminPartnerQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminPartnersApi as r } from "@maat/api-main";
//#region src/partners/admin/useReviewPartnerApplicationMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ id: e, data: t }) => r.reviewApplication(e, t),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.applications() }), i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useReviewPartnerApplicationMutation };
